import React from 'react'
import classnames from 'classnames'
import { Select } from 'antd'
import {
    DropdownViewSelectOption,
    DropdownViewWithSelectAll,
    selectOptionMatchesFilter,
} from '../dropdown-view-with-select-all/dropdown-view-with-select-all'
import './domain-audience-select.scss'

export type DomainAudienceSelectProps = {
    disabled?: boolean
    value?: number[]
    domainSelectorOptions: DropdownViewSelectOption<number>[]
    onChange: (selections: number[]) => void
    onClear: () => void
    onDeselect?: (selection: number) => void
    onDropdownVisibleChange?: (visible: boolean) => void
    handleDomainIdsChange: (domainIds: number[], requiresValidation?: boolean) => void
    domainIdChangeRequiresValidation?: boolean
}

const DomainAudienceSelect: React.FC<DomainAudienceSelectProps> = (props) => {
    const [search, setSearch] = React.useState<string>('')
    const [dropdownOpen, setDropdownOpen] = React.useState<boolean>(false)

    const {
        value,
        disabled,
        domainSelectorOptions,
        handleDomainIdsChange,
        onChange,
        onClear,
        onDeselect,
        onDropdownVisibleChange,
        domainIdChangeRequiresValidation,
    } = props

    const [filteredOptions, setFilteredOptions] =
        React.useState<DropdownViewSelectOption<number>[]>(domainSelectorOptions)

    function handleSearch(searchValue: string) {
        setSearch(searchValue)
        setFilteredOptions(domainSelectorOptions.filter((option) => selectOptionMatchesFilter(searchValue, option)))
    }

    return (
        <Select<number[]>
            allowClear={true}
            onClear={onClear}
            aria-label="Select domains to include"
            // `domain-audience-select` is this component's own, and carries its width. The other two
            // are hooks the notification and app-message builders style against; they are kept so
            // those surfaces keep their own spacing.
            className={classnames(
                'domain-audience-select',
                'org-notification-domain-audience-select',
                'included-audience-select',
            )}
            disabled={disabled}
            value={value}
            mode="multiple"
            placeholder="Select at least one domain to include"
            optionFilterProp="title"
            optionLabelProp="title"
            filterOption={selectOptionMatchesFilter}
            onSearch={handleSearch}
            searchValue={search}
            options={domainSelectorOptions}
            dropdownClassName="org-notification-domain-audience-select-dropdown"
            open={dropdownOpen}
            onDeselect={(selection) => {
                if (onDeselect && !dropdownOpen) {
                    onDeselect(selection)
                }
            }}
            onDropdownVisibleChange={(open) => {
                setDropdownOpen(open)
                if (onDropdownVisibleChange) onDropdownVisibleChange(open)
            }}
            dropdownRender={(menu) => (
                <DropdownViewWithSelectAll
                    selectAllOptionClassName="domain-select-all-option"
                    menu={menu}
                    options={filteredOptions}
                    selectedOptions={value ?? []}
                    filter={search}
                    onChange={(selections) => {
                        handleDomainIdsChange(selections, domainIdChangeRequiresValidation)
                        setSearch('')
                    }}
                />
            )}
            onChange={onChange}
        />
    )
}

export default DomainAudienceSelect
